
import { Helmet } from 'react-helmet-async';
import React, { useEffect, useState } from 'react';
import MerNotifica from '../MerNotifica'
import {
  Typography,
  Container,
  Grid,
  Card,
  CardMedia,
  Stack,
  Link,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Skeleton,
} from '@mui/material';
import CreateTable from './CreateTable';
import TableSvg from './TableSvg';
import axios from 'src/api/axios';
import { DeleteTABLE, ResetTABLE, TABLE, TABLES, TABLESTATUS, archiveNotification } from 'src/constants/url';
import { onMessageListener } from 'src/firebase';
import { Spinner } from 'react-bootstrap';

function OneTable ({FetchNotifications}) {
  let roles = localStorage.getItem("role_name");
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablesStatus , setTabelStatus] = useState([])
  const [tablesOrders , setTablesOrders] = useState([])
  const [pendingOrders , setPendingOrders] = useState([])
  const [DoneOrders , setDoneOrders] = useState([])
  const [inProgressOdrers , setInProgressOrders] = useState([])
  const [needBill,setNeedBill] = useState([])
  const [needPrivacy,setNeedPrivacy] = useState([])
  const [needHelp ,setNeedHelp] = useState([])
  const [all ,setAll] = useState([])
  const [tablesOrdersShow , setTablesOrdersShow] = useState(tablesOrders)
  const [next_page_url , set_next_page_url] = useState() ;
  const [last_page_url , set_last_pag   ] = useState() ;
  const [res , setRes] = useState() ;
  const [total , setTotal] = useState(1)
  const [activeBut , setActivebut] = useState(null);
  const [addNewPopUp , setAddNewPopUP] = useState(0)
  const [addNewPopUpLoader , setAddNewPopUPLoader] = useState(0)
  const [deletePopUp , setDeletePopUP] = useState(0)
  const [deletedTableNumber , setDeletedTableNumber] = useState(0)
  const [deletePopUpLoader , setDeletePopUPLoader] = useState(0)
  const [ResetPopUp , setResetPopUP] = useState(0)
  const [ResetPopUpLoader , setResetPopUPLoader] = useState(0)
  const handleButtonClick = (buttonId) => {
    setActivebut(buttonId);
  };
  const FetchTablesData = async() => {
    // setLoading(true);
    await axios.get(`${TABLES}?page=${currentPage}` , {
      headers : {
        Accept: 'application/json',
      }
    }).then(res => {
      if(res.status === 200) {
        setRes(res)
        // setTablesOrders(res.data.data.tablesOrders.data)
        // if(localStorage.getItem("Table_Noti_Type"))
        if(localStorage.getItem("Table_Noti_Type") === null && role_name === "Waiter"){
          localStorage.setItem("Table_Noti_Type","all")
          setActivebut(1)
          setTotal(res.data.data.tablesOrders.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === null && role_name === "Captain"){
          localStorage.setItem("Table_Noti_Type","all")
          setActivebut(1)
          setTotal(res.data.data.tablesOrders.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === null && role_name === "Chef"){
          localStorage.setItem("Table_Noti_Type","all")
          setActivebut(1)
          setTotal(res.data.data.tablesOrders.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "help") {
          setTablesOrdersShow(res.data.data.needHelp.data)
          setActivebut(5)
          setTotal(res.data.data.needHelp.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "privacy") {
          setTablesOrdersShow(res.data.data.needPrivacy.data)
          setActivebut(6)
          setTotal(res.data.data.needPrivacy.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "bill") {
          setTablesOrdersShow(res.data.data.needBill.data)
          setActivebut(7)
          setTotal(res.data.data.needBill.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "done") {
          setTablesOrdersShow(res.data.data.done.data)
          setActivebut(4)
          setTotal(res.data.data.done.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "pending") {
          setTablesOrdersShow(res.data.data.pending.data)
          setActivebut(3)
          setTotal(res.data.data.pending.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "in_progress") {
          setTablesOrdersShow(res.data.data.inProgress.data)
          setActivebut(2)
          setTotal(res.data.data.inProgress.last_page)
        }
        if(localStorage.getItem("Table_Noti_Type") === "all") {
          setTablesOrdersShow(res.data.data.tablesOrders.data)
          setActivebut(1)
          setTotal(res.data.data.tablesOrders.last_page)
        }
        setAll(res.data.data.tablesOrders.data)
        setPendingOrders(res.data.data.pending.data)
        setInProgressOrders(res.data.data.inProgress.data)
        setNeedBill(res.data.data.needBill.data)
        setNeedHelp(res.data.data.needHelp.data)
        setNeedPrivacy(res.data.data.needPrivacy.data)
        setDoneOrders(res.data.data.done.data)
        setTablesOrders(res.data.data.tablesOrders.data)
      }
    })
    // setLoading(false);
  }
  const FetchTableStatus = async() => {
    await axios.get(TABLESTATUS , {
      headers : {
        Accept: 'application/json',
      }
    }).then(res => {
        let tableSt = res.data.data.tables_status ; 
        setTabelStatus(tableSt)
        localStorage.setItem("TheLasttableNumber" , tableSt.length)
    })
  }
  const [donenoti , setDoneNoti] = useState(false)
  const [vanishNoti , setVanishNoti] =useState(null)
  const [spinner , setSpinner] =useState(null)
  useEffect(()=>{
    FetchTableStatus()
  },[reload,vanishNoti])
  useEffect(()=>{
if(role_name !== "SuperAdmin")
    FetchTablesData()
  },[currentPage,vanishNoti])
  const disablePrev = currentPage === 1 || last_page_url === null;
  const disableNext = currentPage === total || next_page_url === null;
  const [index, setIndex] = useState(0);
  const handlePrevClick = () => {
    if (!disablePrev) {
      setCurrentPage(currentPage - 1);
      setIndex(index - 1)
    }
  };

  // Handle "Next" button click.
  const handleNextClick = () => {
    if (!disableNext) {
      setCurrentPage(currentPage + 1);
      setIndex(index + 1)
    }
  };
  const [classNoti , setCalssNoti] = useState("")
  const [notiArray, setNotiArray] = useState([]);
  onMessageListener() 
    .then(payload =>{
      FetchNotifications()
      FetchTablesData()
      FetchTableStatus()
      if(payload.data.type === "Help" || payload.data.type === "Privacy" || payload.data.type === "Bill" || payload.data.type === "Completed"){
        return payload
        }else {
          return null
          }
          })
          .then((payload) => {
      if(payload !== null){
        if (notiArray === null) {
          setNotiArray([
              {
                id : payload === null ? "" : payload.messageId,
                noti : payload.data.type,
                table_number: parseInt(payload.data.table_number),
              },
            ]);
        } else {
            setNotiArray([ ...notiArray,
              {
                id : payload === null ? "" : payload.messageId,
                noti : payload.data.type,
              table_number: parseInt(payload.data.table_number),
            },
          ]);
        }
      }
      }
    ).finally(()=>{
      localStorage.setItem("waiter_notifications",JSON.stringify(notiArray))
    })
    let role_name = localStorage.getItem("role_name")

    const handleNotification = async (e)=>{
      setDoneNoti(true)
      setSpinner(e.id)
      await axios.post(archiveNotification , {
        notification_id : e.id,
        table_number : String(e.table_number),
        type : e.order_status
      },{
        headers : {
          Accept: 'application/json',
        }
      }).then(res => {
        if(res.status === 200) {
          setDoneNoti(false)
          setVanishNoti(e.id)
          setSpinner(null)
        }
      })
    } 
    const [captainStatus , setCaptainStatus] = useState(0)
    const addNewTableAPI = async() => {
      await  axios.post(TABLE,{}, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setAddNewPopUP(0)
          setAddNewPopUPLoader(0)
          FetchTableStatus()
        }
      })
      .catch((error) => {
        setAddNewPopUPLoader(0)
      })
    }
    const DeleteTableAPI = async() => {
      await  axios.delete(DeleteTABLE, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setDeletePopUP(0)
          setDeletePopUPLoader(0)
          FetchTableStatus()
        }
      })
      .catch((error) => {
        setDeletePopUPLoader(0)
      })
    }
    const ResetTableAPI = async(tabelNum) => {
      await  axios.post(`${ResetTABLE}/${tabelNum}`, {} , {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setResetPopUP(0)
          setResetPopUPLoader(0)
          FetchTableStatus()
        }
      })
      .catch((error) => {
        setResetPopUPLoader(0)
      })
    }
  return (
    <div style={{ marginLeft: "10px", marginRight: "10px"}}>
      <Helmet>
        <title>Tables | Fenice Palas</title>
      </Helmet>
      {/* <Container> */}
      <MerNotifica noti={notiArray} setNotiArray={setNotiArray} classNoit={classNoti} reload={reload} setReload={setReload}/>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h4" sx={{ mb: 2 }} className="nameTable">
          Tables
        </Typography>
        <CreateTable reload={reload} setReload={setReload} setAddNewPopUP={setAddNewPopUP} />
      </div>
      <Grid container item style={{overflow : "hidden"}}  >
        <Grid item  xs={12} lg={role_name === "SuperAdmin" ? 12 : 8} xl={role_name === "SuperAdmin" ? 12 :8} md={role_name === "SuperAdmin" ? 12 : 7} sm={role_name === "SuperAdmin" ? 12 : 12}  style={{ border: "none" }}>
        <Grid item  >
          </Grid>
          <Grid container item xs={12} lg={12} xl={12} md={12} sm={12} className={roles === "Captain" ? "tablecard" : "d-none"} spacing={2} style={{ marginTop: '20px', display: 'flex', justifyContent: 'center'}}>
          <div className='captain-picker'>
            <p className={!captainStatus ? 'ls active' : 'ls'} onClick={() => setCaptainStatus(0)}>Orders</p>
            <p className={captainStatus ? 'rs active' : 'rs'} onClick={() => setCaptainStatus(1)}>Support</p>
          </div>
            <div className='tables-container'>
            {
              tablesStatus.map((e,i) => {
                let colorT = "white" ;
                let color2 = "#231f20" ;
                let textColor = "#A2774C" ;
                if(e.status === "empty"){
                  if(!captainStatus) {
                    colorT = "white";
                    color2 = "#231F20";
                  }
                    if(captainStatus) {
                      if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter") ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          textColor = "#CDA34F";
                          if(e.needBill){
                        colorT = "rgb(177,135,50)";
                        color2 = "#231F20";
                        textColor = "rgba(0, 0, 0, 0.62)"
                      }
                    }
                  }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    textColor = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                      textColor = "rgba(0, 0, 0, 0.62)"
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                }
                }
                if(e.status === "in_progress"){
                  if(!captainStatus){
                    colorT = "#5DD39E";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                    if(captainStatus) {
                      if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter") ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          textColor = "#CDA34F";
                          if(e.needBill){
                            colorT = "rgb(177,135,50)";
                        color2 = "#231F20";
                        textColor = "rgba(0, 0, 0, 0.62)"
                      }
                    }
                  }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    textColor = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                      textColor = "rgba(0, 0, 0, 0.62)"
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                }
                }
                if(e.status === "pending"){
                  if(!captainStatus) {
                    colorT = "#E8D821";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                    if(captainStatus) {
                      if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter")  ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          textColor = "#CDA34F";
                          if(e.needBill){
                        colorT = "rgb(177,135,50)";
                        color2 = "#231F20";
                        textColor = "rgba(0, 0, 0, 0.62)"
                      }
                    }
                  }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    textColor = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                      textColor = "rgba(0, 0, 0, 0.62)"
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                }
                }
                if(e.status === "busy_table"){
                  if(!captainStatus) {
                    colorT= "#F5E0AC";
                    color2 = "#231F20";
                  }
                    if(captainStatus){
                      if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter") ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          if(e.needBill){
                            colorT = "rgb(177,135,50)";
                            color2 = "#231F20";
                          }
                        }
                      }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                  }
                }
                }
                return (
                  <div key={i} className="tablecard">
                      <div className="TableContent">
                        <TableSvg key={`table-${i}`} textColor={textColor} color={colorT} color2={color2} newOrder={e.bell} tabelNumber={e.table_number} setDeletePopUP={setDeletePopUP} setDeletedTableNumber={setDeletedTableNumber} setResetPopUP={setResetPopUP} />
                      </div>
                    </div>
                  );
                })
              }
            </div>
            </Grid>
          <Grid container item xs={12} lg={12} xl={12} md={12} sm={12} className={roles !== "Captain" ? "tablecard" : "d-none"} spacing={2} style={{ marginTop: '20px', display: 'flex', justifyContent: 'center'}}>
            <div className='tables-container'>
            {
              tablesStatus.map((e,i) => {
                let colorT = "white" ;
                let color2 = "#231f20" ;
                let textColor = "#A2774C" ;
                if(e.status === "empty"){
                  colorT = "white";
                  color2 = "#231F20";
                  if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter") ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          textColor = "#CDA34F";
                          if(e.needBill){
                        colorT = "rgb(177,135,50)";
                        color2 = "#231F20";
                        textColor = "rgba(0, 0, 0, 0.62)"
                      }
                    }
                  }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    textColor = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                      textColor = "rgba(0, 0, 0, 0.62)"
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                }
                if(e.status === "in_progress"){
                  colorT = "#5DD39E";
                  color2 = "#231F20";
                  textColor = "rgba(0, 0, 0, 0.62)"
                  if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter") ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          textColor = "#CDA34F";
                          if(e.needBill){
                            colorT = "rgb(177,135,50)";
                            color2 = "#231F20";
                        textColor = "rgba(0, 0, 0, 0.62)"
                      }
                    }
                  }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    textColor = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                      textColor = "rgba(0, 0, 0, 0.62)"
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                }
                if(e.status === "pending"){
                    colorT = "#E8D821";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                    if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter")  ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          textColor = "#CDA34F";
                          if(e.needBill){
                        colorT = "rgb(177,135,50)";
                        color2 = "#231F20";
                        textColor = "rgba(0, 0, 0, 0.62)"
                      }
                    }
                  }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "black";
                    color2 = "#CDA34F";
                    textColor = "#CDA34F";
                    if(e.needBill){
                      colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                      textColor = "rgba(0, 0, 0, 0.62)"
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                    textColor = "rgba(0, 0, 0, 0.62)"
                  }
                }
                if(e.status === "busy_table"){
                  colorT= "#F5E0AC";
                    color2 = "#231F20";
                      if(e.needPrivacy && (role_name === "Captain" || role_name === "Waiter") ) {
                        colorT = "#B2B2B2";
                        color2 = "#231F20";
                        if(e.needHelp){
                          colorT = "black";
                          color2 = "#CDA34F";
                          if(e.needBill){
                            colorT = "rgb(177,135,50)";
                            color2 = "#231F20";
                          }
                        }
                      }else if(e.needHelp && (role_name === "Captain" || role_name === "Waiter") ){
                        colorT = "black";
                        color2 = "#CDA34F";
                        if(e.needBill){
                          colorT = "rgb(177,135,50)";
                      color2 = "#231F20";
                    }
                  }else if(e.needBill && (role_name === "Captain" || role_name === "Waiter") ){
                    colorT = "rgb(177,135,50)";
                    color2 = "#231F20";
                  }
                }
                return (
                  <div key={i} className="tablecard">
                      <div className="TableContent">
                        <TableSvg key={`table-${i}`} textColor={textColor} color={colorT} color2={color2} newOrder={e.bell} tabelNumber={e.table_number} setDeletePopUP={setDeletePopUP} setDeletedTableNumber={setDeletedTableNumber} setResetPopUP={setResetPopUP} />
                      </div>
                    </div>
                  );
                })
              }
            </div>
            </Grid>
            </Grid>
            <Grid item xs={12} lg={4} xl={4} md={5} sm={12} className={role_name === "SuperAdmin" ? "d-none" : ""} style={{ marginTop: "20px"}}>
        <Grid item style={{overflow : "hidden" }}>
            <div className="notes" style={{
              padding: "10px",
              borderRadius: "16px",
              backgroundColor: "white",
              }} >
              <div className="btnNotes" style={{ display: 'flex', justifyContent: "flex-start", flexWrap: "wrap" }}>
                <button id="Allbutton" className={activeBut === 1 ? "btnNote1 active" : "btnNote1"} variant="contained" style={{ margin : "5px" , color : "black" , fontWeight : "600" , border : "2px solid black"}} onClick={() => {setTablesOrdersShow(all); localStorage.setItem("Table_Noti_Type","all") ;setTotal(res.data.data.tablesOrders.last_page);handleButtonClick(1)}}>
                  All
                </button>
                <button className={roles === "Waiter" ? "btnNote1 d-none" : activeBut === 2 ?  "btnNote1 active"  : "btnNote1"} variant="contained" style={{ margin: "5px" , backgroundColor : "#5DD39E" , color : "black", fontWeight : "600" , border : "2px solid black" }} onClick={() => {setTablesOrdersShow(inProgressOdrers); localStorage.setItem("Table_Noti_Type","in_progress") ; setTotal(res.data.data.inProgress.last_page);handleButtonClick(2)}}>
                  In Progress
                </button>
                <button className={roles === "Waiter" ? "btnNote1 d-none" : activeBut === 3 ?  "btnNote1 active"  : "btnNote1"} variant="contained" style={{ margin : "5px" , backgroundColor : "#E8D821" , color : "black", fontWeight : "600" , border : "2px solid black"  }} onClick={() => {setTablesOrdersShow(pendingOrders) ; localStorage.setItem("Table_Noti_Type","pending") ; setTotal(res.data.data.pending.last_page);handleButtonClick(3)}}>
                  Pending
                </button>
                <button id="doneOrd" className={activeBut === 4 ? "btnNote1 active" : roles === "Waiter" || roles === "Captain" ? "btnNote1" : "btnNote1 d-none"} variant="contained" style={{ margin : "5px" , backgroundColor : "#F5E0AC" , color : "black", fontWeight : "600" , border : "2px solid black" }} onClick={() => {setTablesOrdersShow(DoneOrders) ; localStorage.setItem("Table_Noti_Type","done"); setTotal(res.data.data.done.last_page);handleButtonClick(4)}}>
                  Done
                </button>
                <button id="doneOrd" className={activeBut === 5 ? "btnNote1 active" : roles === "Waiter" || roles === "Captain" ?"btnNote1" : "btnNote1 d-none"} variant="contained" style={{ margin : "5px" , backgroundColor : "black" , color : "rgba(205, 163, 79, 0.96)", fontWeight : "600" , border : "2px solid rgba(205, 163, 79, 0.96)" }} onClick={() => {setTablesOrdersShow(needHelp) ;localStorage.setItem("Table_Noti_Type","help") ;setTotal(res.data.data.needHelp.last_page);handleButtonClick(5)}}>
                  Help
                </button>
                <button id="doneOrd" className={activeBut === 6 ? "btnNote1 active" : roles === "Waiter" || roles === "Captain" ?"btnNote1" : "btnNote1 d-none"} variant="contained" style={{ margin : "5px" ,  backgroundColor : "#B9BCB9" , color : "black", fontWeight : "600" , border : "2px solid black"  }} onClick={() => {setTablesOrdersShow(needPrivacy) ;localStorage.setItem("Table_Noti_Type","privacy");setTotal(res.data.data.needPrivacy.last_page); handleButtonClick(6)}}>
                  Privacy
                </button>
                <button id="doneOrd" className={activeBut === 7 ? "btnNote1 active" : roles === "Waiter" || roles === "Captain" ?"btnNote1" : "btnNote1 d-none"} variant="contained" style={{ margin : "5px" ,  backgroundColor : "#BA9A55" , color : "black", fontWeight : "600" , border : "2px solid black" }} onClick={() => {setTablesOrdersShow(needBill) ;localStorage.setItem("Table_Noti_Type","bill"); setTotal(res.data.data.needBill.last_page); handleButtonClick(7)}}>
                  Bill  
                </button>
              </div>
              <hr/>
              <Grid item  xs={12} lg={12} xl={12} md={12} sm={12} style={{position :"relative" , minHeight : "450px"}}  >
              <TableContainer  style={{
                overflowX : "hidden",
                fontFamily : " 'Poppins', sans-serif",
                }}>
                  { 
                    tablesOrdersShow.map((e, i) => {
                      let backGroundColor = "#EAF0F0";
                      let textColor = "black";
                      let status = e.order_status.replace("_", " ");
                      let show = true ;
                      let show2 = true ;
                      if (e.order_status === "help"){
                        backGroundColor = "black",
                        textColor = "white"
                        status = "Need A Question"
                        show = true
                      }
                      if (e.order_status === "privacy"){
                        backGroundColor = "#B9BCB9",
                        textColor = "black"
                        status = "Need Privacy"
                        show = true
                      }
                      if(e.order_status === "bill"){
                        backGroundColor = "#BA9A55";
                        status = "Need Bill"
                        show = true
                      } 
                      if(e.order_status === "to_do") {
                        backGroundColor = "#EAF0F0"
                        textColor = "black";
                        status = e.order_status.replace("_", " ");
                        show = true
                      }
                      if(e.order_status === "done") {
                        backGroundColor = "#EAF0F0"
                        textColor = "black";
                        status = "Ready";
                        show = false;
                        show2 = false
                      }
                      if(e.order_status === "pending") {
                        backGroundColor = "#E8D821"
                        textColor = "black";
                        status = "Ready";
                        show = false;
                        show2 = false
                      }
                      if(e.order_status === "in_progress") {
                        backGroundColor = "#5DD39E"
                        textColor = "black";
                        status = "Ready";
                        show = false;
                        show2 = false
                      }
                      if(e.order_status === "done") {
                        backGroundColor = "#F5E0AC"
                        textColor = "black";
                        status = "Ready";
                        show = true;
                        show2 = true
                      }
                      return(
                        <Table key={i} className={vanishNoti===e.id ? "set-vanish AllTable1":"AllTable1"} style={{backgroundColor : backGroundColor,}}>
                        <TableBody>
                          <TableRow key={`row-${i}`}  style={{display : "flex" , justifyContent : "space-around" , alignItems : "center"}}>
                            <TableCell>
                              <Typography><span style={{color : textColor }}>Table No.</span></Typography>
                              <p className="dataTable" style={{ fontSize: "21px" , color : textColor}}>{e.table_number}</p>
                            </TableCell>
                            <TableCell>
                              <Typography style={{marginTop : "-3px"}}><span style={{color : textColor}}>Bill No.</span></Typography>
                              <p style={{ fontSize: "14px",color : textColor , marginBottom : "0" , fontSize : "14px" , paddingTop : "6px"}}>{show ? "---" : "#"+e.bill_number}</p>
                            </TableCell>
                            <TableCell>
                              <Typography><span style={{color : textColor}}>Time</span></Typography>
                              <p className="dataTable" style={{ fontSize: "12px" , color : textColor }}>{e.created_at.slice(11, 19)}</p>
                            </TableCell>
                            <TableCell className={roles === "Waiter" && status !== "Need Privacy" ? "" : "d-none"}>
                            {spinner === e.id ? <Spinner animation="border" variant="primary" style={{width : "30px", height : "30px"}}/>:<Typography className='check-noti' onClick={()=>handleNotification(e)}>{
                              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 23 23" fill="none">
                              <g clipPath="url(#clip0_1878_6057)">
                              <path d="M11.5 0C5.15869 0 0 5.15896 0 11.5C0 17.841 5.15869 23 11.5 23C17.8413 23 23 17.841 23 11.5C23 5.15896 17.8413 0 11.5 0ZM16.9014 10.2198L11.5606 15.5605C10.9746 16.1465 10.0254 16.1465 9.43943 15.5605L6.34863 12.4697C5.76267 11.884 5.76267 10.9343 6.34863 10.3486C6.93459 9.76265 7.88379 9.76265 8.46975 10.3486L10.5 12.3786L14.7802 8.09856C15.3662 7.5126 16.3154 7.5126 16.9014 8.09856C17.4873 8.68434 17.4873 9.63404 16.9014 10.2198Z" fill="#0093f4"/>
                              <path d="M16.9014 10.2198L11.5606 15.5605C10.9746 16.1465 10.0254 16.1465 9.43943 15.5605L6.34863 12.4697C5.76267 11.884 5.76267 10.9343 6.34863 10.3486C6.93459 9.76265 7.88379 9.76265 8.46975 10.3486L10.5 12.3786L14.7802 8.09856C15.3662 7.5126 16.3154 7.5126 16.9014 8.09856C17.4873 8.68434 17.4873 9.63404 16.9014 10.2198Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_1878_6057">
                              <rect width="23" height="23" rx="11.5" fill="white"/>
                              </clipPath>
                              </defs>
                              </svg>
                            }</Typography>}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                        )
                      })
                  }
                  <div style={{ position : "absolute" , bottom : "-15px", right : "50%" , transform : "scale(1.4) translateX(35%)" }}>
                  <div className="counter">
                    <button
                      className="paginate-left"
                      onClick={handlePrevClick} disabled={disablePrev}
                    >
                      <i className="fa-solid fa-chevron-left"></i>
                    </button>
                    {index + 1} - {total}
                    <button
                      className="paginate-right"
                      onClick={handleNextClick} disabled={disableNext}
                    >
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </TableContainer>
              </Grid>
              </div>
          </Grid>
        </Grid>
      </Grid>
      <div className={addNewPopUp ? "add-new-table-overlay"  : "d-none"}>
        <div className="add-new-table-box">
          <svg style={{margin : "46px auto 0 auto"}} xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
          <path d="M29.7916 21.6667C29.7916 20.1709 31.0042 18.9583 32.5 18.9583C33.9958 18.9583 35.2083 20.1709 35.2083 21.6667V29.7917H43.3333C44.8291 29.7917 46.0416 31.0042 46.0416 32.5C46.0416 33.9958 44.8291 35.2083 43.3333 35.2083H35.2083V43.3333C35.2083 44.8292 33.9958 46.0417 32.5 46.0417C31.0042 46.0417 29.7916 44.8292 29.7916 43.3333V35.2083H21.6666C20.1709 35.2083 18.9583 33.9958 18.9583 32.5C18.9583 31.0042 20.1709 29.7917 21.6666 29.7917H29.7916V21.6667Z" fill="url(#paint0_linear_2073_1487)"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M62.2916 32.5C62.2916 48.9534 48.9534 62.2917 32.5 62.2917C16.0465 62.2917 2.70831 48.9534 2.70831 32.5C2.70831 16.0465 16.0465 2.70834 32.5 2.70834C48.9534 2.70834 62.2916 16.0465 62.2916 32.5ZM8.14348 32.5C8.14348 45.9518 19.0483 56.8566 32.5 56.8566C45.9517 56.8566 56.8566 45.9518 56.8566 32.5C56.8566 19.0483 45.9517 8.14351 32.5 8.14351C19.0483 8.14351 8.14348 19.0483 8.14348 32.5Z" fill="url(#paint1_linear_2073_1487)"/>
          <defs>
          <linearGradient id="paint0_linear_2073_1487" x1="32.5" y1="19.912" x2="32.5" y2="46.0417" gradientUnits="userSpaceOnUse">
          <stop stopColor="#CDA34F"/>
          <stop offset="1" stopColor="#A77C27"/>
          </linearGradient>
          <linearGradient id="paint1_linear_2073_1487" x1="32.5" y1="4.80635" x2="32.5" y2="62.2917" gradientUnits="userSpaceOnUse">
          <stop stopColor="#CDA34F"/>
          <stop offset="1" stopColor="#A77C27"/>
          </linearGradient>
          </defs>
          </svg>
          <h3>Are you sure you want to add new Table ? </h3>
          <div className="btns-conf-container">
            <div className="cancel-table" onClick={() => {setAddNewPopUP(0)}}>Cancel</div>
            <div className="yes-table" onClick={() => {addNewTableAPI();setAddNewPopUPLoader(1)}}>{addNewPopUpLoader ? <Spinner variant='light' animation='border' /> : "Yes, Add"}</div>
          </div>
        </div>
      </div>
      <div className={deletePopUp ? "add-new-table-overlay" : "d-none"}>
        <div className="add-new-table-box">
          <svg style={{margin : "46px auto 0 auto"}} xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
            <path d="M52.9285 43.4286C61.1734 43.4286 67.8571 50.1123 67.8571 58.3572C67.8571 66.602 61.1734 73.2857 52.9285 73.2857C44.6837 73.2857 38 66.602 38 58.3572C38 50.1123 44.6837 43.4286 52.9285 43.4286ZM38 5.42859C43.8145 5.42859 48.5615 9.99936 48.8438 15.7439L48.8571 16.2857H62.4285C63.9276 16.2857 65.1428 17.501 65.1428 19C65.1428 20.392 64.095 21.5393 62.7451 21.696L62.4285 21.7143H60.1241L58.5111 41.6158C56.7566 41.031 54.8796 40.7143 52.9285 40.7143C43.1847 40.7143 35.2857 48.6133 35.2857 58.3572C35.2857 63.0988 37.1562 67.4035 40.1995 70.5737L29.2236 70.5714C23.9211 70.5714 19.5069 66.5006 19.0783 61.2155L15.8731 21.7143H13.5714C12.1794 21.7143 11.0322 20.6665 10.8754 19.3166L10.8571 19C10.8571 17.608 11.9049 16.4608 13.2549 16.304L13.5714 16.2857H27.1428C27.1428 10.2895 32.0037 5.42859 38 5.42859ZM48.1267 51.637L47.9388 51.4799C47.4759 51.1593 46.8582 51.1593 46.3954 51.4799L46.2074 51.637L46.0504 51.8249C45.7298 52.2877 45.7298 52.9055 46.0504 53.3683L46.2074 53.5563L51.0105 58.359L46.2145 63.1546L46.0574 63.3426C45.7368 63.8054 45.7368 64.4232 46.0574 64.886L46.2145 65.0739L46.4024 65.231C46.8652 65.5516 47.483 65.5516 47.9458 65.231L48.1337 65.0739L52.9295 60.278L57.7312 65.08L57.9191 65.2371C58.382 65.5577 58.9997 65.5577 59.4625 65.2371L59.6505 65.08L59.8075 64.8921C60.1281 64.4292 60.1281 63.8115 59.8075 63.3487L59.6505 63.1607L54.8485 58.359L59.658 53.5564L59.815 53.3684C60.1356 52.9056 60.1356 52.2879 59.815 51.8251L59.658 51.6371L59.47 51.4801C59.0072 51.1594 58.3895 51.1594 57.9267 51.4801L57.7387 51.6371L52.9295 56.44L48.1267 51.637ZM38 10.8572C35.1381 10.8572 32.7935 13.0717 32.5863 15.8806L32.5714 16.2857H43.4285L43.4137 15.8806C43.2064 13.0717 40.8618 10.8572 38 10.8572Z" fill="url(#paint0_linear_2073_1368)"/>
            <defs>
              <linearGradient id="paint0_linear_2073_1368" x1="39.3571" y1="7.81792" x2="39.3571" y2="73.2857" gradientUnits="userSpaceOnUse">
                <stop stopColor="#CDA34F"/>
                <stop offset="1" stopColor="#A77C27"/>
              </linearGradient>
            </defs>
          </svg>
          <h3>Are you sure you want to delete table {deletedTableNumber} ?</h3>
          <div className="btns-conf-container">
            <div className="cancel-table" onClick={() => {setDeletePopUP(0)}}>Cancel</div>
            <div className="yes-table" onClick={() => {DeleteTableAPI();setDeletePopUPLoader(1)}}>{deletePopUpLoader ? <Spinner variant='light' animation='border' /> : "Yes, Delete"}</div>
          </div>
        </div>
      </div>
      <div className={ResetPopUp ? "add-new-table-overlay" : "d-none"}>
        <div className="add-new-table-box">
          <svg style={{margin : "26px auto 0 auto"}} xmlns="http://www.w3.org/2000/svg" width="91" height="91" viewBox="0 0 91 91" fill="none">
            <path d="M19.5337 49.3436C19.1409 48.9711 18.5229 48.9787 18.1395 49.3609L17.4607 50.0375L18.1568 50.6983C18.5496 51.0712 19.168 51.0636 19.5515 50.6811L20.23 50.0042L19.5337 49.3436ZM35.631 55.6919C36.0191 56.0695 36.6373 56.0695 37.0255 55.6919L55.1722 38.0404C55.5759 37.6478 55.5759 36.9994 55.1722 36.6067L53.8371 35.3081C53.4489 34.9306 52.8307 34.9306 52.4426 35.3082L34.296 52.9596C33.8923 53.3522 33.8923 54.0005 34.2959 54.3932L35.631 55.6919ZM34.296 36.6067C33.8923 36.9994 33.8923 37.6477 34.296 38.0404L52.4425 55.6919C52.8307 56.0695 53.4489 56.0695 53.8371 55.6919L55.1723 54.3932C55.5759 54.0005 55.5759 53.3522 55.1723 52.9595L37.0254 35.3082C36.6373 34.9306 36.0191 34.9306 35.6309 35.3082L34.296 36.6067ZM68.8838 45.5C68.8838 58.4735 58.0716 68.9907 44.7341 68.9907V72.8C60.2343 72.8 72.8 60.5772 72.8 45.5H68.8838ZM20.5843 45.5C20.5843 32.5265 31.3965 22.0093 44.7341 22.0093V18.2C29.2337 18.2 16.6681 30.4226 16.6681 45.5H20.5843ZM44.7341 22.0093C58.0716 22.0093 68.8838 32.5265 68.8838 45.5H72.8C72.8 30.4226 60.2343 18.2 44.7341 18.2V22.0093ZM20.0551 48.7276C20.477 48.5575 20.7286 48.1244 20.686 47.6715C20.6187 46.9569 20.5843 46.2326 20.5843 45.5H16.6681C16.6681 46.285 17.3192 47.3211 17.7806 48.2552C18.0707 48.8425 18.8118 49.2288 19.4193 48.9839L20.0551 48.7276ZM44.7341 68.9907C36.7911 68.9907 29.7428 65.2622 25.3387 59.4986C25.0095 59.0678 24.4028 58.9511 23.9509 59.2507L22.3823 60.2906C21.9136 60.6013 21.7918 61.2385 22.1315 61.6867C27.2391 68.4238 35.4609 72.8 44.7341 72.8V68.9907ZM20.23 50.0042L27.4589 42.7942C27.8576 42.3965 27.8494 41.7482 27.4409 41.3606L26.0888 40.078C25.6959 39.7054 25.0778 39.7131 24.6944 40.0955L17.7255 47.0463C17.5343 47.2371 17.4284 47.497 17.4318 47.7671L17.4607 50.0375L20.23 50.0042ZM19.4676 48.0371C19.8665 47.6396 19.8586 46.9912 19.4501 46.6036L12.5406 40.0449C12.1478 39.6721 11.5297 39.6797 11.1462 40.062L9.82812 41.3757C9.42928 41.7733 9.4372 42.4216 9.84563 42.8093L17.4607 50.0375L19.4676 48.0371Z" fill="#CDA34F" fillOpacity="0.958352"/>
          </svg>
          <h3>Are you sure you want to reset table {deletedTableNumber} ?</h3>
          <div className="btns-conf-container">
            <div className="cancel-table" onClick={() => {setResetPopUP(0)}}>Cancel</div>
            <div className="yes-table" onClick={() => {ResetTableAPI(deletedTableNumber);setResetPopUPLoader(1)}}>{ResetPopUpLoader ? <Spinner variant='light' animation='border' /> : "Yes, Reset"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneTable;

















